export default __webpack_public_path__ + "static/media/language.1b2252f7.svg";